module.exports = __webpack_public_path__ + "static/header_bg-5c62efefef91c28b7d40fdff779531c7.png";